import { LeadGenAPIResponse, LeadData, AssignCompanyData, FilterLeadGenInput, LeadGenSourceAPIResponse, LeadGensource,DownloadLeadGenUsersAPIResponse } from 'types';
import { baseApi } from './axios';
import { API_ENDPOINT } from 'src/config/env.config';

const baseURL = `${API_ENDPOINT}/lead-gen`;

export const uploadLeadGen = async (payload: { data: LeadData[] }): Promise<LeadGenAPIResponse> => {
	const response = await baseApi.post(`${baseURL}/upload-lead-gen-csv`, payload);
	return response.data;
};

export const getLeadGenData = async (args: FilterLeadGenInput,): Promise<LeadGenAPIResponse> => {
	const response = await baseApi.get(`${baseURL}/getAllLeadGens`, { params: args });
	return response.data;
};

export const downloadLeadGenUsers = async (
	args: FilterLeadGenInput,
): Promise<DownloadLeadGenUsersAPIResponse> => {
	const response = await baseApi.get(`${baseURL}/download-leadGens-users`, { params: args });
	return response.data;
};

export const createLeadGen = async (payload: LeadData): Promise<LeadGenAPIResponse> => {
	const response = await baseApi.post(`${baseURL}/create`, payload);
	return response.data;
};

export const createLeadGenSource = async (payload: LeadGensource): Promise<LeadGenAPIResponse> => {
	const response = await baseApi.post(`${baseURL}/addLeadGenSource`, payload);
	return response.data;
};

export const assignBDPOC = async (payload: AssignCompanyData): Promise<LeadGenAPIResponse> => {
	const response = await baseApi.post(`${baseURL}/assignBDPOC`, payload);
	return response.data;
};


export const addLog = async ({ ids, data }: { ids: string[]; data: any }): Promise<LeadGenAPIResponse> => {
	const response = await baseApi.post(`${baseURL}/add-log`, { ids, data });
	return response.data;
}

export const reAssignLeadGenPOC = async ({ id, data }: { id: string[]; data: any }): Promise<LeadGenAPIResponse> => {
	const response = await baseApi.post(`${baseURL}/reassign-lead-gen-poc`, data);
	return response.data;
}

export const getAllLeadGensUser = async (): Promise<LeadGenAPIResponse> => {
	const response = await baseApi.get(`${baseURL}/users`);
	return response.data;
}
export const getAllLeadGensSource = async (): Promise<LeadGenSourceAPIResponse> => {
	const response = await baseApi.get(`${baseURL}/getAllLeadGenSource`);
	return response.data;
}

export const updateLeadgen = async ({ id, action }: { id: string; action: string }): Promise<LeadGenAPIResponse> => {
	const response = await baseApi.patch(`${baseURL}/update`, { params: { id, action } });
	return response.data;
};